import React from 'react';
import { myWalletAddCcButtonRendered } from '@wix/bi-logger-cashier-ugc/v2';
import { getBiLogger } from '../../utils/biLogger';
import { DH } from '../../utils/DataHook';
import { t } from '../../utils/i18n';
import s from './styles.scss';

export type AddPaymentMethodButtonViewProps = {
  onClick(): void;
};

export const AddPaymentMethodButtonView: React.FC<AddPaymentMethodButtonViewProps> = (props) => {
  React.useEffect(() => {
    getBiLogger().report(myWalletAddCcButtonRendered({}));
  }, []);

  return (
    <button data-hook={DH.AddPaymentMethodButton} className={s.addPaymentMethodButton} onClick={props.onClick}>
      {t('app.add-payment-method.button')}
    </button>
  );
};
